import React from "react";
import { DeleteDialog } from "../../components";
import { Panel } from "../../components/panels";
import { usePagination } from "../../utilities/hookutils";
import { routes } from "utilities/routing/generatedRoutes";
import { ButtonPrimary } from "components/Atoms/Button";
import TwoColumnLayout from "layout/TwoColumnLayout";
import RightSideNavigation from "components/RightSideNavigation/RightSideNavigation";
import { PhosphorTrashButton } from "components/Atoms/PhosphorIconButton";
import { useLoaderData } from "react-router";

const FormattedBankAccount = (props: { bankAccount: server.dto.BankAccount }) => {
  return <table>
    <tbody>{
      props.bankAccount.formatted.map((line, idx) => {
        return <tr key={`${props.bankAccount.bankAccountId}_${idx}`}>
          <td className="padding-right s1_gray" style={{ width: 150 }}>{line.label}:</td>
          <td>{line.value}</td>
        </tr>;
      })}
    </tbody>
  </table>;
};

const BankAccountList = () => {
  const viewModel = useLoaderData<server.viewmodel.BankAccountListFrontModel>();

  const [bankAccounts, setBankAccounts] = React.useState<server.dto.BankAccount[]>([]);
  const [paginationData, setPaginationData] = React.useState<server.dto.PaginationData>(undefined);
  const [deletingBankAccount, setDeletingBankAccount] = React.useState<server.dto.BankAccount>();
  const [loading, setLoading] = React.useState(true);

  const perPage = 20;

  const paginate = async (paginationData: Partial<server.dto.PaginationData>) => {
    const result = await window.CoreApi.BankAccount.ListBankAccount({
      page: paginationData.page,
      perPage
    });

    setBankAccounts(result.data.data ?? []);
    setLoading(false);
    setPaginationData(result.data.pagination);

    return result.data.pagination;
  };

  const pagination = usePagination(perPage, paginate);

  const onDeleteClicked = (bankAccount: server.dto.BankAccount) => {
    setDeletingBankAccount(bankAccount);
  };

  const onDelete = async () => {
    await window.CoreApi.BankAccount.DeleteBankAccount(deletingBankAccount.bankAccountId);
    setDeletingBankAccount(undefined);
    pagination.onPaginate(paginationData.page);
  };

  return <TwoColumnLayout>
    <TwoColumnLayout.LeftColumn>
      <Panel
        headerSize="h1"
        title={`${viewModel.pageTitle}: ${paginationData?.total ?? ""}`}
        button={<ButtonPrimary
          label={RESX.Buttons.btnNew}
          href={routes.bankAccount_New().absolute}
        />}
        panelClassName="s1_listview-panel"
        hasData={bankAccounts.length > 0}
        isLoading={loading}
        pagination={pagination.Component}
        articleId={serverReference.supportArticleIds.whatIsABankAccount}
      >
        {bankAccounts.length > 0 && <div className="list-with-gaps line-layout">
          <div className="list-with-gaps-body">
            {bankAccounts.map(bankAccount => {
              return <div key={bankAccount.bankAccountId}>
                <div className="grow1 flex-column gap-small">
                  <div><a href={routes.bankAccount_Detail(bankAccount.bankAccountId).absolute} className="table-main-link">{bankAccount.title}</a></div>
                  <div><FormattedBankAccount bankAccount={bankAccount} /></div>
                </div>
                <PhosphorTrashButton
                  layout="in-square"
                  onClick={() => onDeleteClicked(bankAccount)} />
              </div>;
            })}
          </div>
        </div>}
        <DeleteDialog
          isOpen={deletingBankAccount != null}
          onDelete={onDelete}
          handleClose={() => { setDeletingBankAccount(undefined); }}
          message={RESX.GeneralWarnings.DeleteSure}
        />
      </Panel>
    </TwoColumnLayout.LeftColumn>
    <RightSideNavigation
      title={site.navigation.rightSideNavigation.title}
      menuItems={site.navigation.rightSideNavigation.items}
      currentPage={site.currentPage}
    />
  </TwoColumnLayout>;
};

export default BankAccountList;